import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
import ActionsCard from './_actions_card';

import { actions } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1),
    background: 'transparent',
  },
  paperTitle: {
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    paddingTop: '5rem',
    paddingBottom: '8rem'
  }
}));

const Actions = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        alignContent="center"
        alignItems="center"
        className={classes.section}
        component="section"
        container
        direction="column"
        justify="center"
        xs={12}
      >
        <Paper
          className={classes.paperTitle}
          component="header"
        >
          <Typography
            align="center"
            component="h2"
            variant="h1"
          >
            nos actions
          </Typography>
          <Typography
            align="center"
            component="p"
            variant="body2"
          >
            Les actions concrètes que SeedOut Fenua réalise.
          </Typography>
        </Paper>
        <Grid
          container
          justify="center"
          lg={8}
          sm={8}
          spacing={1}
          xs={12}
        >
          {actions.map((action, index) => {
            return (
              <Grid
                item
                key={`action-${index}`}
                md={6}
                sm={12}
                xs={10}
              >
                <Paper
                  className={classes.paper}
                  elevation={0}
                >
                  <ActionsCard action={action}/>
                </Paper>
              </Grid>
            )
          })}
        </Grid>
      </Grid>

    </>
  );
}

export default Actions;
